import {
  AfterViewInit, ChangeDetectorRef, Component, HostBinding, Input, NgZone,
  OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SohoModalDialogService, SohoTabsComponent, } from 'ids-enterprise-ng';
import { LMBaseComponent } from '@base/lm-base.component';
import { LMBannerHeaderComponentRef } from '@banner/lm-banner-header-component-ref.service';
import { LMContextService } from '@services/lm-context.service';
import {
  LMLoggerService,
  LMBusyIndicatorService,
  LMAccessibleWebAppService,
  LMErrorUtilService,
  LMRouteComponentService,
  LMComponentInfoService,
  RoamingUIProfileResponse,
  RoamingUIProfileResult,
  LMRoamingUIProfileService,
  LMFormatUtilService,
  LMSpecService,
  LMUrlInfoBuilderService,
  LMUrlUtilService,
  LMActionService,
} from '@app/services';
import { LMGlobalPersonalizationService } from '@states/services/lm-global-personalization.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { Observable, Subscription } from 'rxjs';
import { LMToolbarComponent } from '@toolbar/lm-toolbar.component';
import { AppConstants, LMGlobalUtilService, LMUniqueIdService } from '@app/utils';
import { LMAppComponentService } from '@utils/lm-app-component.service';
import {
  LMApplicationMenuService, LMListContext, LMListTransactionService,
  LMPrintDialogService,
  LMReportPersonalizationDialogResult,
  LMReportPersonalizationDialogResultCode,
  LMReportPersonalizationDialogService,
  SaveRequired
} from '@app/components';
import { LMCreateReportDialogService } from '@report/index';
import { LMReportsListComponent } from './lm-reports-list.component';
import { LMReportsCatalogToolbarService } from './lm-reports-catalog-toolbar.service';
import { LMReportsCatalogService } from './lm-reports-catalog.service';
import { LMPersonalizationDialogOption, LMReport, LMReportCategoriesByModule, LMReportsResponse, ReportUrlVariables } from '../lm-reports';
import { LMGlobalPersonalization } from '@app/states';
import { LMTransactionState } from '@app/transaction';
import { LMComponentTrackerService } from '@services/lm-component-tracker.service';

@Component({
  selector:    'lm-reports-catalog',
  templateUrl: './lm-reports-catalog.component.html',
  styleUrls:   [ 'lm-reports-catalog.component.scss' ],
  providers:   [
  LMReportsCatalogToolbarService,
  LMRoamingUIProfileService,
  LMComponentTrackerService],
  })
export class LMReportsCatalogComponent extends LMBaseComponent implements AfterViewInit, OnInit, OnDestroy, SaveRequired {

  // ---------------------
  // Page layout variables
  // ---------------------
  private toolbarButtonSubscription: Subscription;
  initialized: boolean = undefined;
  public displayDataGrid = false;
  public toolbarButtons: Observable<Array<LMToolbarButton>>;
  private toolbarActionRefArray: Array<LMBusActionReference> = [];
  private subscriptionsArray: Array<Subscription> = [];
  public pageTitle = Soho.Locale.translate('ReportCatalog');
  private screenId = 'ReportCatalog';
  public globalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
  public catalogTabTitle = Soho.Locale.translate('Reports');
  public printFilesTabTitle = Soho.Locale.translate('PrintFiles');
  private initializeSohoTabs = true;
  public printFilesEnabled: boolean;
  public doRetrievePrintFilesSpec = true;
  public TAB_ID_ALLREPORTS = 'lm-allreports-tab-content';
  public TAB_ID_PRINTFILES = 'lm-printfiles-tab-content';

  // --------------------------
  // WebApp/Category Tab variables
  // --------------------------
  private favoritesStringArray: Array<string>;
  public reportsArray: Array<LMReport> = [];
  public categoriesByModule: LMReportCategoriesByModule;

  // -----------------------------
  // Create Report modal variables
  // -----------------------------
  private createReportUrl: string;
  private actorGroupSelectUrl: string;
  private roleSelectUrl: string;
  private roleGroupSelectUrl: string;
  private reportFieldSearchUrl: string;

  private PRINT_FILES_LIST = 'UserReport.MyUserReportsCatalogList';
  public printFilesListSpec: LMListSpec;
  public printFilesListUrlInfo: LMListUrlInfo;
  private REPORT_CATALOG_DATA_LIST = 'ReportDefinition.ReportCatalogDataList';
  public reportDefinitionListSpec: LMListSpec;
  public reportDefinitionListUrlInfo: LMListUrlInfo;
  private readonly instanceId: string;
  private updateAllReports = false;

  @ViewChild(LMToolbarComponent) toolbar: LMToolbarComponent;
  @ViewChild(SohoTabsComponent) tabs: SohoTabsComponent;
  @ViewChild('modalPlaceholder', { read: ViewContainerRef, static: true }) modalPlaceholder: ViewContainerRef;
  @ViewChildren(LMReportsListComponent) lmReportsListComponents: QueryList<LMReportsListComponent>;

  @HostBinding('class.form-layout-compact') @Input() useCompactFormLayout: boolean;
  @HostBinding('class.lm-display-type-is-smartphone') displayTypeIsSmartPhone: boolean;

  constructor(
    public    router: Router,
    public    route: ActivatedRoute,
    public    sohoModalDialogService: SohoModalDialogService,
    private   lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    private   lmReportsCatalogToolbarService: LMReportsCatalogToolbarService,
    public    lmContextService: LMContextService,
    private   lmContextUtilService: LMContextUtilService,
    private   lmCreateReportDialogService: LMCreateReportDialogService,
    private   lmErrorUtilService: LMErrorUtilService,
    private   lmFormatUtilService: LMFormatUtilService,
    private   lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private   lmGlobalUtilService: LMGlobalUtilService,
    private   lmLoggerService: LMLoggerService,
    private   lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    private   lmRoamingUIProfileService: LMRoamingUIProfileService,
    private   lmRouteComponentService: LMRouteComponentService,
    private   lmSpecService: LMSpecService,
    private   lmUrlUtilService: LMUrlUtilService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    private   lmReportsCatalogService: LMReportsCatalogService,
    protected lmAppComponentService: LMAppComponentService,
    private   lmPrintDialogService: LMPrintDialogService,
    private   lmListTransactionService: LMListTransactionService,
    private   lmActionService: LMActionService,
    private   lmComponentTrackerService: LMComponentTrackerService,
  ) {
    super (sohoModalDialogService, lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService);
    this.instanceId = this.lmLoggerService.instanceId;
    // setTimeout(() => {
    //   this.zone.run(() => {
    //     this.changeDetectionRef.detectChanges();
    //   });
    // });
  }

  ngOnInit() {
    this.lmLoggerService.time({ id: '>> Reports Catalog' + this.instanceId});
    this.lmRouteComponentService.setRouteComponent(this as Component);
    this.lmBusyIndicatorService.showBusyIndicator();
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;
    this.displayTypeIsSmartPhone = this.lmContextService.isMobileDevice();

    this.retrieveReportsCatalogSpecJSON();
  }

  ngAfterViewInit() {
    const context = this.lmContextService.getContext();
    const configuredFeatures = context.configuredFeatures;
    this.printFilesEnabled = !configuredFeatures.includes('HideMenuPrintFiles');
    const createReportEnabled = configuredFeatures.includes(AppConstants.FEATURE_CreateReport);

    if (createReportEnabled) {
      this.toolbarActionRefArray = [{
        id: 'reports-catalog-create',
        automationId: 'reports-catalog-create',
        icon: 'create',
        label: Soho.Locale.translate('CreateReport'),
        type: 'standard',
      }];
    }

    this.buildToolBar();
    this.sendShortcut();
    setTimeout(() => {this.initialized = true;});
  }

  ngAfterViewChecked() {
    this.initializeTabs();
  }

  public getSpec() {
    return undefined;
  }

  public isRouteReuseActive(): boolean {
    return false;  // nothing currently implemented
  }

  public setRouteReuseActive(active: boolean): void {
    // noop att his point
  }

  private initializeTabs() {
    if (this.initializeSohoTabs && this.tabs && this.tabs.getVisibleTabs().length > 0) {
      this.initializeSohoTabs = false;
      let activeTab = this.lmReportsCatalogService.getActiveTab();
      const paramTab = this.lmUrlUtilService.getUrlParam(window.location.href, 'selectedPanel');
      if (paramTab) {
        activeTab = 'lm-' + paramTab + '-tab-content';
      }
      if (activeTab) {
        this.tabs.select(activeTab);
      } else {
        this.tabs.select(this.TAB_ID_ALLREPORTS);
      }
      this.tabs.disableAutoUpdatedCall = true;
      this.lmBusyIndicatorService.hideBusyIndicator();
    }
  }

  ngOnDestroy() {
    this.subscriptionsArray.forEach(subscription => {
      subscription.unsubscribe();
    });
    this.lmReportsCatalogToolbarService.reset();
    this.initialized = undefined;
    if (this.lmContextService.isTrackerEnabled()) {
      this.lmComponentTrackerService.endComponentTracking();
    }
    setTimeout(() => {
      this.lmBannerHeaderCompRef = undefined;
    });
  }

  private retrieveReportsCatalogSpecJSON(forceReload?: boolean, postContentIn?: any, extraParams?: LMUrlParams): void {
    const storedSpec = this.lmReportsCatalogService.getStoredCatalogSpec();
    if (storedSpec && !forceReload) {
      this.unpackSpec(storedSpec);
      this.displayDataGrid = true;
      this.lmBusyIndicatorService.hideBusyIndicator();
    } else {
      this.lmReportsCatalogService.getReportsCatalogData(postContentIn, extraParams)
        .subscribe((response: LMReportsResponse) => {
          if (response.status === 'SUCCESS') {
            this.lmReportsCatalogService.setStoredCatalogSpec(response);
            this.unpackSpec(response);
            this.displayDataGrid = true;
          } else {
            this.lmLoggerService.log([ this, this.instanceId, 'retrieveReportsCatalogSpecJSON() error', response ]);
            console.warn('Invalid Catalog Response:', response);
          }
          if (!this.initializeSohoTabs) {
            this.lmBusyIndicatorService.hideBusyIndicator();
          }
          this.pageAnalytics();
        });
    }
  }

  private unpackSpec(spec: LMReportsResponse): void {
    this.reportsArray = spec['reportsJSONArray'];
    this.favoritesStringArray = spec['favoritesStringArray'];
    this.categoriesByModule = spec['categoriesByModule'];
    this.setCreateReportUrls(spec['createReportUrls']);
  }

  private sendShortcut(): void {
    const shortcutTitle = `${this.pageTitle} / ${this.lmContextService.getContext().webAppTitle}`;
    this.lmContextUtilService.enableStandardShortcut(true, shortcutTitle);
  }

  onSendContextMessageEvent(event: any) {
    this.sendBusinessContext(event);
  }

  public sendBusinessContext(contextMsgs?: any): void {
    this.lmContextUtilService.clearAll();
    this.lmContextUtilService.buildContextMessages({
      busFormName:           this.screenId,
      busClassName:          this.lmContextService.getContext().webApp, // since no busclass for a page use webApp name.
      widgetEventPrefix:     AppConstants.RESOURCETYPE_REPORTCATALOG,
    })
      .subscribe((msgObj: any) => {
        if (msgObj.status === AppConstants.STATUS_COMPLETED) {
          if (contextMsgs) {
            msgObj = this.lmContextUtilService.mergeContextMessages({ sourceMsgs: msgObj, addMsgs: contextMsgs });
          }
          this.lmContextUtilService.sendContextMessages(msgObj);
        }
      });
  }

  private retrievePrintFilesSpec() {
    this.lmReportsCatalogService.getListSpec(this.PRINT_FILES_LIST)
      .subscribe((response) => {
        this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog retrievePrintFilesSpec() completed', response ]);
        if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
          this.handleSpecResponseError((response as LMSystemException));
          return;
        }
        this.printFilesListSpec = (response as LMListSpecResponse).listSpec;
        this.printFilesListUrlInfo = (response as LMListSpecResponse).listUrlInfo;
        this.displayDataGrid = true;
        if (!this.initializeSohoTabs) {
          this.lmBusyIndicatorService.hideBusyIndicator();
        }
      });
  }

  private buildToolBar() {
    if (this.lmContextService.inMingleWidget()) {
      return;
    }
    this.lmBannerHeaderCompRef.instance.toolbarButtons = this.lmReportsCatalogToolbarService.getToolbarButtonsObservable();

    setTimeout(() => {
      // need to place in a timeout so the toolbarService has a change to set its observable member.
      this.lmBannerHeaderCompRef.instance.screenId = this.screenId;
      this.lmBannerHeaderCompRef.instance.screenAutomationId = this.screenId;
      this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = this.pageTitle;
      this.lmReportsCatalogToolbarService.buildToolbar(this.toolbarActionRefArray);
      if (!this.lmContextService.isBannerInRoute() && this.lmContextService.showBreadcrumbs()) {
        this.lmBannerHeaderCompRef.resetBreadCrumbs('ReportCatalog');
        this.lmBannerHeaderCompRef.updateBreadcrumbs({
          id: undefined,
          category: 'ReportCatalog',
          busClass: '',
          specName: 'ReportCatalog',
          type: 'SYSTEM',
          title: this.pageTitle,
          routeUrl: this.router.url
        });
      }
      this.subscriptionsArray.push(this.lmBannerHeaderCompRef.instance.toolbarButtonEvent.subscribe((e) => {
        if (e.actionReference?.id === 'reports-catalog-create') {
          this.runCreateReport();
        }
      }));
    }, 1);
    const globalPersonalization: LMGlobalPersonalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
    if (globalPersonalization.color === 'alabaster') {
      setTimeout(() => { // Make "Create Report" button primary if toolbar is white
        const toolbar = document.getElementsByClassName('flex-toolbar-main-app-content')[0];
        const buttonsContainer = toolbar?.getElementsByClassName('toolbar-section buttonset')[0];
        const buttons = buttonsContainer?.getElementsByClassName('btn');
        for (const buttonsKey in buttons) {
          if (buttons[buttonsKey] && buttons[buttonsKey] instanceof Object) {
            const btn = (buttons[buttonsKey]) as HTMLElement;
            if (btn.classList) {
              btn.classList.add('btn-primary');
              btn.classList.add('lm-report-toolbar');
            }
          }
        }
      }, 1);
    }
  }

  private reloadReports() {
    this.lmBusyIndicatorService.showBusyIndicator();
    this.retrieveReportsCatalogSpecJSON(true);
  }

  // Triggered by clicking "Create Report" in toolbar, see runCreateReport() in lm-application-menu-base
  public runCreateReport(): void {
    this.lmCreateReportDialogService.openCreateReportDialog(
      'createReportFromBanner',
      this.modalPlaceholder,
      this.createReportUrl,
      this.actorGroupSelectUrl,
      this.roleSelectUrl,
      this.roleGroupSelectUrl,
      this.reportFieldSearchUrl
    ).subscribe((result: LMReportPersonalizationDialogResult) => {
      if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED) {
        if (result.viewReport) {
          this.lmGlobalUtilService.navigateByUrl(result.reportUrl);
        } else {
          this.reloadReports();
          this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
        }
      }
      return;
    });
  }

  onReportListEvent($event: any) {
    if ($event.type === 'favoriteClicked') {
      this.onFavoriteClicked($event);
    } else if ($event.type === 'emptyStateClicked') {
      this.onEmptyStateClicked($event.value);
    } else if ($event.type === 'deleteReport') {
      this.deleteUserFolderReport($event.item);
    } else if ($event.type === 'runPersonalization') {
      this.runReportPersonalization($event.item);
    } else if ($event.type === 'exportToCsv' || $event.type === 'printToPdf') {
      this.runReportsExportAction($event.item, $event.type);
    } else if ($event.type === 'reassignReportOwner') {
      this.runReassignReportOwner($event.item, $event.type);
    } else if ($event.type === 'copy') {
      this.runCopyReport($event.item);
    }

  }

  private onFavoriteClicked($event: any) {
    const report: LMReport = $event.item;
    const isExistingFavorite = report.isFavorite;
    if (isExistingFavorite && this.favoritesStringArray.indexOf(report.id) !== -1) { // Remove from Favorites
      const favoritesIndex = this.favoritesStringArray.indexOf(report.id);
      this.favoritesStringArray.splice(favoritesIndex, 1);
      this.updateRoamingUIProfileFavorites();
    } else if (!isExistingFavorite && this.favoritesStringArray.indexOf(report.id) === -1) { // Add to Favorites
      if (Array.isArray(this.favoritesStringArray)) {
        this.favoritesStringArray.push(report.id);
      } else {
        this.favoritesStringArray = [ report.id ];
      }
      this.updateRoamingUIProfileFavorites();
    } else {
      this.lmLoggerService.log('Warning: problem in Report Catalog > onFavoriteClicked with report: ' + report.id);
      return;
    }
  }

  private updateRoamingUIProfileFavorites() {
    this.lmRoamingUIProfileService.setFavoriteReports(this.favoritesStringArray.toString())
      .subscribe(
        (results: RoamingUIProfileResponse) => {
          if (results.status === RoamingUIProfileResult.COMPLETED) {
            this.lmLoggerService.log('RoamingUIProfile Updated');
          } else {
            this.lmLoggerService.log('Warning: RoamingUIProfile NOT Updated');
            // console.log('Favorites not updated', results.status);
          }
        });
  }

  private onEmptyStateClicked(action: string){
    if (action === 'switch-tab') {
      this.tabs.select(this.TAB_ID_ALLREPORTS);
    } else if (action === 'create-report') {
      this.runCreateReport();
    }
  }

  private deleteUserFolderReport(report: LMReport ) {
    this.lmReportsCatalogService.deleteUserFolderReport(report.id)
      .subscribe(
        (response: any) => {
          if (response.status === AppConstants.STATUS_COMPLETED) {
            this.reloadReports();
            const message = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('DeleteActionCompleteSuccessResults'), "1");
            this.lmGlobalUtilService.displayToastMessage('', message);
          } else {
            this.lmGlobalUtilService.displayToastMessage('', 'Unable to delete report');
          }
        }
      );
  }

  private runReportPersonalization(report: LMReport, param?: LMPersonalizationDialogOption) {
    // Retrieve list spec before running dialog
    const url = this.lmReportsCatalogService.buildReportUrl(report);
    this.lmSpecService.getListSpec(url)
      .subscribe((response) => {
        this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog > runReportPersonalization > getListSpec() completed', response ]);
        if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
          this.handleSpecResponseError((response as LMSystemException));
          return;
        }
        const listSpec = (response as LMListSpecResponse).listSpec;
        const listUrlInfo = (response as LMListSpecResponse).listUrlInfo;

        const mode = param?.mode || 'personalizeReport';
        const reportType = param?.reportType;
        const busClassName = report?.busClass;
        const listName = listSpec?.busListSpec?.name;
        const userFolderId = report.id;
        const selectedFields = param?.selectedFields;
        const title = listSpec.busListSpec.title.resourceValue + (param?.reportType === 'ReportCopiedFromReport' || param?.reportType === 'ReportCopiedFromList' ? '_Copy' : '');
        const personalizationExists = mode === 'personalizeReport';
        const createReportMode = mode === 'createReportFromBanner';

        this.lmReportPersonalizationDialogService.runReportPersonalizationDialog(
          mode,
          this.modalPlaceholder,
          reportType,
          busClassName,
          listName,
          userFolderId,
          selectedFields,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          title,
          listUrlInfo,
          listSpec,
          undefined,
          undefined,
          personalizationExists,
          listSpec.includeBaseFilter,
          listSpec.filterCondition,
          undefined,
          createReportMode
        ).subscribe((result: LMReportPersonalizationDialogResult) => {
          if (result.status === LMReportPersonalizationDialogResultCode.REPORT_PERSONALIZATION_DIALOG_SAVED) {
            this.lmGlobalUtilService.displayToastMessage('', result.message, AppConstants.TRA_ACTION_COMPLETED);
            this.reloadReports();
          }
        });
      });
  }

  private runReportsExportAction(report: LMReport, type: string) { // Note: only valid for lists
    this.lmBusyIndicatorService.showBusyIndicator();

    const url = this.lmReportsCatalogService.buildReportUrl(report);
    if (report.type.toUpperCase() === 'LIST') {
      this.lmSpecService.getListSpec(url)
        .subscribe((response) => {
          this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog > runReportsExportAction > getListSpec() completed', response ]);
          if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
            this.handleSpecResponseError((response as LMSystemException));
            return;
          }
          const listSpec = (response as LMListSpecResponse).listSpec;
          const listUrlInfo = (response as LMListSpecResponse).listUrlInfo;
          if (type === 'exportToCsv') {
            const settings = this.lmReportsCatalogService.buildListCsvSettings(report, listSpec, listUrlInfo, this.modalPlaceholder);
            this.lmPrintDialogService.openCsvDialog(settings);
          } else if (type === 'printToPdf') {
            const settings = this.lmReportsCatalogService.buildListPdfSettings(report, listSpec, listUrlInfo);
            this.lmPrintDialogService.openPdfDialog(settings);
          }
          this.lmBusyIndicatorService.hideBusyIndicator();
        });
    } else {
      this.lmLoggerService.log('Unable to export report; Invalid report type: ' + report.type);
    }
  }

  private runReassignReportOwner(report: LMReport, type: string) {
    this.lmBusyIndicatorService.showBusyIndicator();

    if (!this.reportDefinitionListUrlInfo || !this.reportDefinitionListSpec) { // only retrieves the list spec once if user does multiple reassignments
      this.lmReportsCatalogService.getListSpec(this.REPORT_CATALOG_DATA_LIST)
        .subscribe((response) => {
          this.lmLoggerService.trace([ this, this.instanceId, 'ReportsCatalog getReportDefinitionDataListSpec() completed', response ]);
          if ((response as LMSystemException).status === AppConstants.STATUS_SYSTEM_ERROR) {
            this.handleSpecResponseError((response as LMSystemException));
            return;
          }
          this.reportDefinitionListSpec = (response as LMListSpecResponse).listSpec;
          this.reportDefinitionListUrlInfo = (response as LMListSpecResponse).listUrlInfo;
          this.runReassignReportOwner(report, type);
        });
    } else {
      this.lmReportsCatalogService.getReportDefinitionRecordDataView(report.id)
        .subscribe((listPagingResponse: LMListPagingResponse) => {
          if (listPagingResponse.serverLog) {
            this.lmLoggerService.serverLog(listPagingResponse.serverLog);
          }
          this.lmBusyIndicatorService.hideBusyIndicator();

          if (listPagingResponse.status === 'COMPLETED' && listPagingResponse.dataViewSet) {
            const listContext: LMListContext = {
              listUrlInfo: this.reportDefinitionListUrlInfo,
              listSpec:    this.reportDefinitionListSpec
            };
            const actionSpec: LMActionSpec = this.lmActionService.getActionByName(this.reportDefinitionListSpec.busClassSpec.actions, 'ReassignReportOwner');
            const dataViewList: LMDataView[] = listPagingResponse.dataViewSet.data;
            if (dataViewList.length === 1) {
              this.lmListTransactionService.runInstanceAction(listContext, actionSpec, listPagingResponse.dataViewSet, dataViewList).subscribe(
                (transactionState: LMTransactionState) => {

                  this.lmBusyIndicatorService.hideBusyIndicator();

                  if (transactionState.isError) {
                    this.lmErrorUtilService.handleError(
                      transactionState.response.message,
                      transactionState.response.details,
                      transactionState.response.status,
                      transactionState.response.message);
                  } else if (transactionState.isCanceled) {
                    // noop
                  } else if (transactionState.isFinished) {
                    const resultList = transactionState.completedTransactionList;
                    this.lmGlobalUtilService.displayToastMessage('', resultList[0].message, AppConstants.TRA_ACTION_COMPLETED);
                    this.reloadReports();
                  }
                });
            } else {
              this.lmLoggerService.log('Warning: problem in Report Catalog > getReportDefinitionRecordDataView with report: ' + report.id);
            }

          } else {
            this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
              listPagingResponse.status, listPagingResponse.message);
          }
        },
        (error: any) => {
          this.lmBusyIndicatorService.hideBusyIndicator();
          this.lmErrorUtilService.handleUnexpectedError(error);
        });
    }
  }

  private runCopyReport(report: LMReport) {
    let reportType: LMReportType = 'ReportCopiedFromReport';

    if (report.id === report.resourceId) {
      reportType = 'ReportCopiedFromList';
      this.lmCreateReportDialogService.reportType = reportType;
      this.lmCreateReportDialogService.businessClass = report.busClass;
      this.lmCreateReportDialogService.listName = report.name;
      report.id = undefined;
    } else {
      this.lmCreateReportDialogService.userFolder = report.id;
    } 

    this.subscriptionsArray.push(
      this.lmCreateReportDialogService.loadData().subscribe((displayFields: unknown[]) => {
        this.runReportPersonalization(report, {
          reportType,
          mode: 'createReportFromBanner',
          selectedFields: displayFields
        });
      })
    );
  }

  private handleSpecResponseError(response: LMSystemException) {
    this.hideBusyIndicator();
    const statusText = response.statusText;
    const details = response.details;
    this.lmErrorUtilService.handleError(statusText, details);
  }

  onTabActivated(event: SohoTabsEvent) {
    if (!this.initializeSohoTabs) {
      const activeTabId = event.tab.getAttribute('href').slice(1); // Removes '#' from beginning of id
      const curActiveTab = this.lmReportsCatalogService.getActiveTab();
      if  (activeTabId !== curActiveTab && activeTabId !== this.printFilesTabTitle) {
        this.lmReportsCatalogService.setActiveTab(activeTabId);
      }
      if (activeTabId === this.TAB_ID_PRINTFILES && this.doRetrievePrintFilesSpec) {
        this.doRetrievePrintFilesSpec = false;
        this.lmBusyIndicatorService.showBusyIndicator();
        this.retrievePrintFilesSpec();
      }
    }
  }

  private setCreateReportUrls(urls) {
    this.createReportUrl = urls.createReportUrl;
    this.actorGroupSelectUrl = urls.actorGroupSelectUrl;
    this.roleSelectUrl = urls.roleSelectUrl;
    this.roleGroupSelectUrl = urls.roleGroupSelectUrl;
    this.reportFieldSearchUrl = urls.reportFieldSearchUrl;
  }

  private pageAnalytics() {
    const loadTime = this.lmLoggerService.timeEnd('>> Reports Catalog' + this.instanceId, [ this, 'retrieveReportsCatalogSpecJSON()', 'end' ]);
    const componentInfo = this.getComponentInfo();
    this.lmComponentTrackerService.endLoadTracking(this.route?.routeConfig?.component?.name, this.router.url, componentInfo, loadTime);
    this.lmComponentTrackerService.startComponentTracking(componentInfo, loadTime);
  }

  getComponentInfo(): LMComponentInfo {
    const formInfo: LMComponentInfo = {
      componentType: 'REPORTS_CATALOG',
      name: 'ReportsCatalog',
      userWebRequestId: this.getUserWebRequestId(),
      type: 'page',
      developer: false,
      isWizard: false,
      panelNavigation: false,
      hasConfigAccess: false,
    };
    return formInfo;
  }

  getComponentPlaceHolder(): ViewContainerRef {
    return undefined;
  }

  public getUserWebRequestId(): string {
    return 'ReportsCatalog' + '-' +this.getBaseCompId();
  }

  // Needed to prevent "Reload site?" popup
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  saveComponentState(includeSubComponents?: boolean): void {}

  checkSaveRequired(): boolean { return false; }

  modalOpen(): boolean {
    return true;
  }
}
